module.exports = __webpack_public_path__ + "media/images/hono-4fa82b13c9b1d9c12841ff6825c82304.ico";